import * as React from 'react';
import {none, option, Option} from "ts-option";
import {FocusableProps} from "../../../../components/common/props/FocusableProps";
import {ClickableProps} from "../../../../components/common/props/ClickableProps";
import {EditableProps} from "../../../../components/common/props/EditableProps";
import {DisableableProps} from "../../../../components/common/props/DisableableProps";
import {PressableProps} from "../../../../components/common/props/PresableProps";
import {PlaceholderProps} from "../../../../components/common/props/PlaceholderProps";
import Input from "./Input";
import CurrencyHelper from "../../../../helper/CurrencyHelper";

interface ComponentProps {
	/**
	 * Number input change callback.
	 */
	onChange: (value: Option<string>) => void;
	/**
	 * Number input value.
	 */
	value?: Option<string>;
}

type Props =
	ComponentProps
	& FocusableProps
	& ClickableProps
	& EditableProps
	& DisableableProps
	& PressableProps
	& PlaceholderProps

export default class CurrencyInput extends React.Component<Props, {}> {
	public static defaultProps: Partial<Props> = {
		value: none
	};

	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Input onChange={this.onChange}
				   onClick={this.props.onClick}
				   focus={this.props.focus}
				   onFocus={this.props.onFocus}
				   onConfirm={this.props.onEnter}
				   type={"text"}
				   placeholder={this.props.placeholder}
				   value={this.props.value.getOrElse("")}
				   readonly={this.props.readonly}
				   disabled={this.props.disabled}/>
		);
	}

	/**
	 * On change action.
	 */
	onChange(evt: React.ChangeEvent<HTMLInputElement>) {
		if (!evt.target.value) {
			this.props.onChange(none);
		}
		else {
			if (CurrencyHelper.isInCurrencyFormat(evt.target.value)) {
				this.props.onChange(option(evt.target.value));
			}
		}
	}
}